import React from 'react';
import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import { CARD_NAMES } from '../../utils/constants';
import { setCardID } from '../../utils/Format/Format';
import { monthlyDistributionUtil } from './util';
import { MONTHLY_DISTRIBUTION } from './query';
import styles from './MonthlyDistribution.css';

const MonthlyDistribution = ({ ticker }) => (
    <Card className="left" id={setCardID(CARD_NAMES.MONTHLY_DISTRIBUTION)}>
        <div className="subsection-no-border" />
        <div>
            <GqlQueryWrapper
                query={MONTHLY_DISTRIBUTION}
                variables={{ ticker }}
                dataFunc={monthlyDistributionUtil}
                placeholder={() => <TablePreRender />}
            >
                {({ data: { rows, headers } }) => (
                    <React.Fragment>
                        <div
                            id="monthly-distribution-table"
                            className="table-container"
                        >
                            <Table
                                data={{ data: rows, headers }}
                                displayTooltip
                            />
                        </div>
                        <div className="monthly-dist-footer-text">
                            <a href="https://www.troweprice.com/personal-investing/resources/planning/tax/etf-distribution-notices.html">
                                View 19(a) Notices for fund here
                            </a>
                        </div>
                    </React.Fragment>
                )}
            </GqlQueryWrapper>
        </div>
        <style jsx>{styles}</style>
    </Card>
);

export default MonthlyDistribution;
